import { render, staticRenderFns } from "./PflegeleistungsfinderWidget.vue?vue&type=template&id=5fd3b362&"
import script from "./PflegeleistungsfinderWidget.vue?vue&type=script&lang=js&"
export * from "./PflegeleistungsfinderWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports